export default __webpack_public_path__ + "static/media/pendingIcon.10ad4edd.svg";